import { environment } from "../../../environments/environment";

export enum NombresModulos {
    ACTIVOS_FIJOS = 'ACTIVOS_FIJOS',
    CONFIGURACION = 'CONFIGURACION',
    HERRAMIENTAS = 'HERRAMIENTAS'
}

export const KEYMODULO = {
    1: [NombresModulos.CONFIGURACION],
    23: [NombresModulos.HERRAMIENTAS]
}

export const MODULOS = {

    [NombresModulos.ACTIVOS_FIJOS]: 14,
    [NombresModulos.CONFIGURACION]: 1,
    [NombresModulos.HERRAMIENTAS]: 23

}

export const MODULOS_ROUTES: Record<NombresModulos, string> = {
    [NombresModulos.ACTIVOS_FIJOS]: null,
    [NombresModulos.CONFIGURACION]: environment.URL_CONFIGURACION,
    [NombresModulos.HERRAMIENTAS]: environment.URL_HERRAMIENTAS
} as const;